module.exports = __webpack_public_path__ + "static/img/r.2aa67c02.png";